
import React, { useEffect, useState } from "react";
import { useWindowSize } from "../../hooks/useWindowSize";

const AnimatedShadows: React.FC = () => {
  const { isMobile } = useWindowSize();
  const [scrollY, setScrollY] = useState(0);
  
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Define different sizes based on the viewport
  const baseShadowSize = isMobile ? "55rem" : "70rem";
  
  // Common styles for all shadows
  const commonStyles = {
    position: "fixed" as const,
    pointerEvents: "none" as const,
    zIndex: "1", // Increase z-index to make shadows visible but still behind content
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(16, 31, 90, 0.7) 0%, transparent 70%)",
    filter: "brightness(1.25)",
    transition: "transform 0.3s ease-out, width 0.5s ease-out, height 0.5s ease-out",
    opacity: "0.8" // Slightly increase opacity to make them more visible
  };

  // Calculate size variations based on scroll
  const sizeVariation1 = Math.sin(scrollY * 0.001) * 5 + "%";
  const sizeVariation2 = Math.cos(scrollY * 0.001) * 5 + "%";
  const sizeVariation3 = Math.sin(scrollY * 0.002 + 1) * 5 + "%";
  const sizeVariation4 = Math.cos(scrollY * 0.002 + 1) * 5 + "%";
  
  return (
    <>
      {/* Top Left Shadow */}
      <div 
        style={{
          ...commonStyles,
          width: `calc(${baseShadowSize} + ${sizeVariation1})`,
          height: `calc(${baseShadowSize} + ${sizeVariation1})`,
          top: "0",
          left: "0",
          transform: `translate(-60%, -50%) translateY(${scrollY * 0.05}px) rotate(${scrollY * 0.01}deg)`,
        }}
      ></div>
      
      {/* Bottom Right Shadow */}
      <div 
        style={{
          ...commonStyles,
          width: `calc(${baseShadowSize} + ${sizeVariation2})`,
          height: `calc(${baseShadowSize} + ${sizeVariation2})`,
          bottom: "0",
          right: "0",
          transform: `translate(60%, 20%) translateX(${scrollY * 0.02}px) translateY(${-scrollY * 0.03}px)`,
        }}
      ></div>
      
      {/* Middle Left Shadow */}
      <div 
        style={{
          ...commonStyles,
          width: `calc(${baseShadowSize} + ${sizeVariation3})`,
          height: `calc(${baseShadowSize} + ${sizeVariation3})`,
          top: "50%",
          left: "0",
          transform: `translate(-70%, -50%) translateX(${scrollY * 0.015}px) translateY(${scrollY * 0.02}px)`,
        }}
      ></div>
      
      {/* Middle Right Shadow */}
      <div 
        style={{
          ...commonStyles,
          width: `calc(${baseShadowSize} + ${sizeVariation4})`,
          height: `calc(${baseShadowSize} + ${sizeVariation4})`,
          top: "70%",
          right: "20%",
          transform: `translate(0%, 0%) translateX(${-scrollY * 0.01}px) translateY(${-scrollY * 0.04}px) rotate(${-scrollY * 0.005}deg)`,
        }}
      ></div>
    </>
  );
};

export default AnimatedShadows;
